import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 14 14",
	width: 14,
	height: 14,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", { d: "M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z" })
	})
});
export default SvgClose;
